<template>
  <div class="header header-color" :style="{backgroundColor: headerBgColor}">
    <div class="Header-container">
      <div class="Header-Logo">
        <div class="Header-Logo-txt">
          <img class="logo-img" ref="logoImg" :src="logoSrc" alt="">
          {{projectName}}
        </div>
      </div>

      <div class="Header-Nav">
        <div class="Header-Nav-Links">
          <div class="menu-content">
            <div class="Header-Nav-Box">
              <div :style="{backgroundColor: /^document\/\w+/.test(curPage) ? headerActiveColor : ''}">
                <router-link class="Header-menu-item" to="/document/0">{{ $t('header.document') }}</router-link>
              </div>
              <div :style="{backgroundColor: curPage === 'download' ? headerActiveColor : ''}">
                <router-link class="Header-menu-item" to="/download">{{ $t('header.download') }}</router-link>
              </div>
              <div v-if="hasAbility" :style="{backgroundColor: curPage === 'abilityInfo' ? headerActiveColor : ''}">
                <router-link class="Header-menu-item" to="/abilityInfo">{{ $t('header.abilityInfo') }}</router-link>
              </div>
            </div>
              <div class="list-item nav-list-item" v-if="manageCenter">
                <router-link class="Header-menu-item" to="/artemis-portal">{{ $t('header.manage') }}</router-link>
              </div>
            </div>
            <div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {  getMenuList, getProjectInfo, searchSceneList, getDisplayConfig } from '@/api'
import logo from '../assets/images/logo_header.png'
export default {
  name: "Header",
  data() {
    return {
      abilityDemo: false,
      manageCenter: false,
      projectName: "",
      headerBgColor: '#2080f7',
      headerActiveColor: '',
      logoSrc: logo,
      curPage: "document",
      hasAbility: false,
    };
  },
  methods: {
    async getMenu() {
      const { data } = await getMenuList();
      // const { data } = "{ability-demo: 'false', manage-center: 'false'}"

      this.abilityDemo = data["ability-demo"] === "true";
      this.manageCenter = data["manage-center"] === "true";
    },
    async getProjectInfo() {
      const lan = this.$cookies.get('portal.locale') || this.$cookies.get('browserLan');
      const { data } = await getProjectInfo(lan);
      // const { data } = "{name: '智能应用平台', headerBgColor: '2080f7', headerActiveColor: '1d73de', logoBase64: ''}"

      this.projectName = data.name;
      document.title = data.name;
      this.headerBgColor = '#' + data.headerBgColor;
      this.headerActiveColor = '#' + data.headerActiveColor;
      if (data.logoBase64) {
        // 替换logo的img的src
        this.logoSrc = data.logoBase64;
      }
    },
    async getAbility() {
      let param = {
        pageNo: 1,
        pageSize: 1,
        abilityName: '',
      };
      console.log(param)
      const me = this
      // 先获取配置文件中配置是否展示能力超市，如果配置为false则直接不展示，为true在查询是否存在能力数据
     await getDisplayConfig()
        .then(function (response) {
          if (response.data.code === '0') {
            var displayConfig = response.data.data
            if (displayConfig['config'] === true) {
              me.hasAbility = true
            } else {
              me.hasAbility = false
            }
          }
        })
        .catch(function () {
          me.hasAbility = false
        })

      if(me.hasAbility === true){
        await searchSceneList(param)
        .then(function (response) {
          if (response.data.code == "0") {
            var sceneAbilityList = response.data.data.list;
            if(sceneAbilityList.length > 0) {
              me.hasAbility = true
            } else {
              me.hasAbility = false
            }
          }
        })
        .catch(function () {
          me.hasAbility = false
        });
      }
    },
  },
  created() {
    this.getMenu();
    this.getProjectInfo();
    this.getAbility();
  },
  watch: {
    $route() {
      this.curPage = this.$route.path.slice(1);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$height: 68px;

.header-color {
  position: fixed;
  width: 100%;
  z-index: 2;
  .Header-container {
    position: relative;
    max-width: 1610px;
    height: $height;
    margin: 0 auto;
    z-index: 2;
    top: 0;
    text-align: center;
    .Header-Logo-txt {
      position: relative;
      height: $height;
      line-height: $height;
      color: #fff;
      font-size: 25px;
      padding-left: 70px;
      margin-left: 30px;
      .logo-img {
        position: absolute;
        top: 10px;
        left: 0;
        width: 45px;
        height: 45px;
      }
    }
    a {
      text-decoration: none;
    }
  }
}

.Header-Logo {
  min-width: 32px;
  float: left;
  height: $height;
  line-height: $height;
  position: relative;
  z-index: 2;
}

.Header-Logo.open {
  background: #16181e;
}

.Header-Nav {
  height: $height;
  line-height: $height;
  margin-left: 100px;
  float: left;
  overflow: hidden;
}

.Header-menu-item {
  font-size: 18px;
  color: #fff;
  cursor: pointer;
  padding: 0 20px;
}


.Header-Nav-Box > div {
  float: left;
}

.Header-Nav-Links.open {
  overflow: auto;
  height: 100%;
}

.Header-User {
  position: absolute;
  top: 0;
  right: 100px;
  min-width: 1100px;
}

@media only screen and (max-width: 1608px) {
}

@media only screen and (max-width: 1412px) {
}

@media only screen and (max-width: 1200px) {
}

@media only screen and (max-width: 1008px) {
  .Header-Nav {
    float: none;
  }

  .Header-Logo-txt {
    width: 0;
    overflow: hidden;
  }
}

@media only screen and (min-width: 769px) {
  .operate {
    display: none;
  }

  .open > .operate {
    display: block;
    min-width: 100%;
    position: absolute;
    top: 100%;
    right: 0;
    background-color: rgba(255, 255, 255, 0.95);
    height: auto;
    border-radius: 6px;
    box-shadow: inset 0 1px 0px rgba(110, 140, 249, 0.7),
      0 1px 8px rgba(16, 0, 255, 0.7);
    text-align: left;
    padding: 2px 0;
  }

  .open > .operate a {
    height: 30px;
    line-height: 30px;
    padding: 2px 30px;
    display: block;
    color: #333;
    font-size: 15px;
  }

  .open > .operate a:hover {
    color: #0886e9;
  }

  .open > .operate:before {
    content: "";
    position: absolute;
    top: -29px;
    border: 15px solid;
    border-color: transparent transparent rgba(255, 255, 255, 0.95);
    right: 100px;
  }
}
@media only screen and (max-width: 768px) {
  /*打开菜单*/
  .menu-open,
  .menu-open body {
    height: 100% !important;
    overflow: hidden !important;
  }

  .menu-open .Header-Nav-Links {
    height: 100%;
    opacity: 0.95;
    filter: progid:DXImageTransform.Microsoft.gradient(
        GradientType=1,
        startColorstr=#0E273A,
        endColorstr=#334456
      );
    background: linear-gradient(140deg, #0e273a 00%, #4f5863 80%, #73767c 100%);
  }
  .menu-open .Header-Nav-Box > div {
    display: block;
    float: none;
    line-height: 50px;
    margin-left: 0;
  }
  .Header-menu-item {
    float: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    text-indent: 30px;
    color: #8f8e8e;
  }
  .menu-content a {
    color: #8f8e8e;
    font-size: 16px;
    cursor: pointer;
    display: block;
    width: 70%;
    text-align: left;
  }
  .menu-open .menu-content {
    top: 060px;
    overflow: auto;
    position: absolute;
    bottom: 0;
    width: 100%;
    padding-top: 020px;
  }
  .background-transition {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
  .menu-open .background-transition {
    opacity: 1;
  }
  /* 打开菜单-结束 */
  .Header-Nav-Links {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    /* background: #16181e; */
    z-index: 1;
    overflow: hidden;
    height: 0;
    opacity: 0;
    // transition:opacity .3s ease-out;
  }
  .Header-User {
    position: static;
    line-height: 50px;
    top: auto;
    right: auto;
  }
  .Header-Logo {
    float: none;
  }

  .Header-Logo-txt {
    width: auto;
    margin-left: 0;
    padding-left: 45px;
  }

  /* 导航菜单 */
  .operate {
    overflow: hidden;
    position: relative;
    left: -20px;
    height: 0;
    opacity: 0;
  }
  .open > .operate {
    left: 0;
    will-change: left, opacity;
    transition: left 0.3s ease-in, opacity 0.3s ease-in;
    height: 100%;
    opacity: 1;
  }
  .menu-content .operate a {
    text-indent: $height;
    cursor: pointer;
    padding: 0 20px;
  }
}
/* topbar */
</style>
